// this file is automatically generated by git-version.ts script
export const version: string = '1.4.3';
export const revision: string = '851f54b';
export const branch: string = 'develop';